import { createFileRoute } from "@tanstack/react-router";
import { TruthEvalPage } from "@client/components/truth/truth-eval-page";

export const Route = createFileRoute("/_app/truth/rounds/$sessionId")({
  component: TruthEvalPage,
});
